import { parseFloatValue } from './parse-float-value';

function stringIsNumber(str: string) {
  if (str === '') {
    return false;
  }

  const num = parseFloatValue(str?.toString());
  return !isNaN(num);
}

export { stringIsNumber };
